import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\CoverController::image
* @see app/Http/Controllers/CoverController.php:32
* @route '/profil/{user}/obalka.jpg'
*/
export const image = (args: { user: string | number } | [user: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: image.url(args, options),
    method: 'get',
})

image.definition = {
    methods: ["get","head"],
    url: '/profil/{user}/obalka.jpg',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\CoverController::image
* @see app/Http/Controllers/CoverController.php:32
* @route '/profil/{user}/obalka.jpg'
*/
image.url = (args: { user: string | number } | [user: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { user: args }
    }

    if (Array.isArray(args)) {
        args = {
            user: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        user: args.user,
    }

    return image.definition.url
            .replace('{user}', parsedArgs.user.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\CoverController::image
* @see app/Http/Controllers/CoverController.php:32
* @route '/profil/{user}/obalka.jpg'
*/
image.get = (args: { user: string | number } | [user: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: image.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\CoverController::image
* @see app/Http/Controllers/CoverController.php:32
* @route '/profil/{user}/obalka.jpg'
*/
image.head = (args: { user: string | number } | [user: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: image.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\CoverController::image
* @see app/Http/Controllers/CoverController.php:32
* @route '/profil/{user}/obalka.jpg'
*/
const imageForm = (args: { user: string | number } | [user: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: image.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\CoverController::image
* @see app/Http/Controllers/CoverController.php:32
* @route '/profil/{user}/obalka.jpg'
*/
imageForm.get = (args: { user: string | number } | [user: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: image.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\CoverController::image
* @see app/Http/Controllers/CoverController.php:32
* @route '/profil/{user}/obalka.jpg'
*/
imageForm.head = (args: { user: string | number } | [user: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: image.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

image.form = imageForm

/**
* @see \App\Http\Controllers\CoverImageController::store
* @see app/Http/Controllers/CoverImageController.php:37
* @route '/profil/nastaveni/obalka'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/profil/nastaveni/obalka',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\CoverImageController::store
* @see app/Http/Controllers/CoverImageController.php:37
* @route '/profil/nastaveni/obalka'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\CoverImageController::store
* @see app/Http/Controllers/CoverImageController.php:37
* @route '/profil/nastaveni/obalka'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\CoverImageController::store
* @see app/Http/Controllers/CoverImageController.php:37
* @route '/profil/nastaveni/obalka'
*/
const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\CoverImageController::store
* @see app/Http/Controllers/CoverImageController.php:37
* @route '/profil/nastaveni/obalka'
*/
storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Http\Controllers\CoverImageController::destroy
* @see app/Http/Controllers/CoverImageController.php:69
* @route '/profil/nastaveni/obalka'
*/
export const destroy = (options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/profil/nastaveni/obalka',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\CoverImageController::destroy
* @see app/Http/Controllers/CoverImageController.php:69
* @route '/profil/nastaveni/obalka'
*/
destroy.url = (options?: RouteQueryOptions) => {
    return destroy.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\CoverImageController::destroy
* @see app/Http/Controllers/CoverImageController.php:69
* @route '/profil/nastaveni/obalka'
*/
destroy.delete = (options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\CoverImageController::destroy
* @see app/Http/Controllers/CoverImageController.php:69
* @route '/profil/nastaveni/obalka'
*/
const destroyForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\CoverImageController::destroy
* @see app/Http/Controllers/CoverImageController.php:69
* @route '/profil/nastaveni/obalka'
*/
destroyForm.delete = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

const cover = {
    image: Object.assign(image, image),
    store: Object.assign(store, store),
    destroy: Object.assign(destroy, destroy),
}

export default cover